import { lazy } from "react";
import AddCharter from "./Flight/Add";
import BookingHistory from "./Flight/Booking";
import CharterFlightList from "./Flight/List";
import TransactionHistory from "./Transaction-history/TransactionHistory";

const Dashboard = lazy(() => import("./Dashboard/Dashboard"));
const EditBookingDetails = lazy(
  () => import("./Flight/BookingDetails/BookingDetails"),
);
const supplierRoutes = [
  {
    path: "/supplier/dashboard",
    element: <Dashboard />,
  },
  {
    path: "/supplier/flight/booking-history",
    element: <BookingHistory />,
  },
  {
    path: "/supplier/flight/list",
    element: <CharterFlightList />,
  },
  {
    path: "/supplier/flight/add",
    element: <AddCharter />,
  },

  {
    path: "/supplier/transaction-log",
    element: <TransactionHistory />,
  },
  {
    path: "/supplier/flight/booking-details/:id",
    element: <EditBookingDetails />,
  },
];

export default supplierRoutes;
